import { Cell as CellType } from '@tanstack/react-table';
import {
  ExpandedCell,
  ExpandedContent,
  ExpandedTitle,
  HorizontalDivider,
} from './common';
import Cell from './Cell';

type ExpandedMobileContentProps<T> = {
  hidden: boolean;
  isExpanded: boolean;
  expandedCells: CellType<T, unknown>[];
};

const ExpandedMobileContent = <T,>({
  hidden,
  isExpanded,
  expandedCells,
}: ExpandedMobileContentProps<T>) => (
  <>
    <HorizontalDivider hidden={!isExpanded} />
    <ExpandedContent hidden={hidden} expanded={isExpanded}>
      {expandedCells.map((cell: CellType<T, unknown>) => {
        return (
          <ExpandedCell key={cell.id}>
            <ExpandedTitle
              hidden={cell.column.columnDef.meta?.isMobileLabelHidden}
            >
              {cell.column.columnDef.header as string}
            </ExpandedTitle>
            <Cell cell={cell} row={cell.row} />
          </ExpandedCell>
        );
      })}
    </ExpandedContent>
  </>
);

export default ExpandedMobileContent;
